import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class SubjectAreaTargetObjectFilterData {
    targetObjects: Array<DropdownOptionIntegerId>;
    platforms: Array<DropdownOptionIntegerId>;
    dataSets: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
}
